'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var classNames = require('classnames');
var capitalize = require('../../../../utils/capitalize.js');
var Button = require('./Button.js');
var ButtonCircularProgressV2 = require('./ButtonCircularProgressV2.js');
var ButtonV2_styles = require('./ButtonV2.styles.js');
var Button$1 = require('../../../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ButtonV2 = function ButtonV2(_ref) {
  var children = _ref.children,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$circularProgress = _ref.circularProgressProps,
      circularProgressProps = _ref$circularProgress === void 0 ? {} : _ref$circularProgress,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      buttonText = _ref.buttonText,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      props = objectWithoutProperties(_ref, ["children", "loading", "disabled", "circularProgressProps", "size", "classes", "className", "buttonText", "color"]);

  var variantProp = props.variant === 'flat' ? 'text' : props.variant;
  var isButtonDisabled = disabled || loading;
  var internalClasses = ButtonV2_styles.useStyles({
    size: size,
    variant: variantProp,
    color: color
  });
  var labelClasses = React.useMemo(function () {
    var labelClasses = [internalClasses.label];
    if (isButtonDisabled) labelClasses.push(internalClasses.labelDisabled);
    return labelClasses.join(' ');
  }, [isButtonDisabled]);
  return React__default["default"].createElement(Button$1["default"], _objectSpread({}, props, {
    color: color,
    className: classNames__default["default"](internalClasses.root, internalClasses[variantProp], defineProperty({}, internalClasses["".concat(variantProp).concat(capitalize(color))], color !== 'primary'), className),
    disabled: isButtonDisabled,
    classes: _objectSpread({
      label: labelClasses,
      startIcon: internalClasses.startIcon,
      endIcon: internalClasses.endIcon
    }, classes),
    size: size,
    variant: variantProp,
    "data-ds-version": "v2"
  }), buttonText, children, loading ? React__default["default"].createElement(ButtonCircularProgressV2, _objectSpread({
    size: size,
    color: color
  }, circularProgressProps)) : null);
};

var ButtonV2WithMonochromeFallback = function ButtonV2WithMonochromeFallback(props) {
  if (props.version === 'v2') {
    return React__default["default"].createElement(Button.ButtonComponent, _objectSpread({}, props));
  }

  return React__default["default"].createElement(ButtonV2, _objectSpread({}, props));
};

exports.ButtonV2 = ButtonV2;
exports["default"] = ButtonV2WithMonochromeFallback;
